import { ENTERED_WIZARD, CREATE_REQUEST_ID }
  from '../actions/types/SelectionCriteriaWizardActionTypes';
import { LOGGED_OUT } from '../../../../../core/modules/security/redux/actions/types/SecurityActionTypes';

export const initialState = {
  selectedReportId: '',
  requestId: '',
};

const handleSelectedReportId = (action, state) => ({
  ...state,
  selectedReportId: action.reportId,
});

const selectionCriteriaWizardReducer = (state = initialState, action) => {
  switch (action.type) {
    case ENTERED_WIZARD:
      return handleSelectedReportId(action, state);
    case CREATE_REQUEST_ID:
      return {
        ...state,
        requestId: action.requestId,
      };
    case LOGGED_OUT:
      return initialState;
    default:
      return state;
  }
};

export default selectionCriteriaWizardReducer;
